<template>
    <div>
        <AppPopover v-if="useDevice().isDesktop" :id="item.title">
            <template #button="{ open }">
                <NuxtLinkLocale
                    :to="item.link"
                    active-class="!text-gray-500"
                    class="text-gray-500 cursor-pointer text-body-md hover:text-gray-100 transition-all"
                    @click.prevent
                >
                    {{ item.title }}
                    <Icon :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'" size="16px" />
                </NuxtLinkLocale>
            </template>

            <template #content>
                <div v-if="item.hasMegaMenu">
                    <AppHeaderMegaMenu :item="item" />
                </div>
                <div v-else class="w-[232px] p-4 rounded-2xl backdrop-blur-lg bg-gray-900">
                    <ul>
                        <AppHeaderSubMenuItem :item="item" />
                    </ul>
                </div>
            </template>
        </AppPopover>

        <ul v-else>
            <button class="text-gray-500" @click="showSubMenuItems = !showSubMenuItems">
                {{ item.title }} <Icon :name="showSubMenuItems ? 'tabler:chevron-up' : 'tabler:chevron-down'" />
            </button>

            <TransitionExpand>
                <div v-if="showSubMenuItems" class="space-y-6 mt-3">
                    <AppHeaderSubMenuItem :item="item" />
                </div>
            </TransitionExpand>
        </ul>
    </div>
</template>

<script setup lang="ts">
import type { IHeaderLinkItem } from "~/types/components/header.type";

interface IProps {
    item: IHeaderLinkItem;
}
const showSubMenuItems = ref(true);

defineProps<IProps>();
</script>
